export default __webpack_public_path__ + "static/media/IMG_0211 copie.ce836c2c.jpg";